function TermsOfUse() {
  return (
    <>
      {" "}
      <section className=" cont-form">
        <div className="container px-0">
          <div className="row privacy">
            <div className="row align-items-center text-center">
              <div className="col-12 ">
                <h1>Cloudlas Apps - Terms Of Use</h1>
                <br />
                <br />
              </div>
            </div>

            <div className="col-sm-12 col-lg-12 priv-cont px-0">
              <h3>ACCEPTANCE OF TERMS </h3>
              <p>
                By using Cloudlas`s online and offline products and services
                (collectively, “the Service”), provided by Cloudlas Solutions
                LLP. (collectively, “Cloudlas,” “We”, “Our” or “Us”) you agree
                to be bound by the following Terms of Service (“TOS”). The TOS
                may be updated by us from time to time without notice.
              </p>
              <p>
                {" "}
                You can review the most current version of the TOS at any time
                at: <a href="TermsOfUse.html"> Terms Of Use</a>
              </p>
              <p>
                <strong>
                  By using the Service provided by Cloudlas, you represent and
                  agree that:
                </strong>
                <br />
                <br />
                (i) you enter into this agreement either on your own, or on
                behalf of the company or other legal entity (collectively, the
                “Business User”) that you may specify,
                <br />
                <br />
                (ii) that your account is for, and held in the name of, the
                Business User of individual named in the subscription, <br />
                <br />
                (iii) such Business User or individual has full legal capacity
                and is in good standing in the jurisdiction in which it is
                formed,
                <br />
                <br />
                (iv) you have full legal capacity and authority to bind yourself
                individually and such Business User to these TOS,
                <br />
                <br />
                (iv) the terms “you” or “your,” as used herein shall, unless the
                context otherwise reasonably requires, refer to both
                <span style={{ color: "#283050" }}>
                  {" "}
                  (a) such Business User, and (b) the individual or individuals
                  (the “Individual User(s)”) accessing or using the Service as
                  authorized by such Business User; provided, however, that each
                  such Individual User(s) shall remain vicariously liable and be
                  required to comply with these TOS even though the account may
                  be held in the name of the Business User. If you do not meet
                  the requirements above, or if you do not agree with these
                  terms and conditions, you may not use the Service.
                </span>
              </p>

              <h3>ACCOUNT</h3>
              <p>
                <strong>
                  In consideration of your use of the Service, you represent and
                  warrant that :
                </strong>
                <br />
                <br />
                (i) you are not barred from receiving services under the laws of
                the United States or any other applicable jurisdiction,
                <br />
                <br /> (ii) your use of the Service does not violate any
                applicable law or regulation, and <br />
                <br />
                (iii) you access the Service through one or more humans.
                Accounts registered by “bots” or other automated methods are not
                permitted. You also agree to:
                <span style={{ color: "#283050" }}>
                  (a) provide true, accurate, current and complete information
                  about yourself as prompted by the Service; and (b) maintain
                  and promptly update the Registration Data to keep it true,
                  accurate, current and complete. If you provide any information
                  that is untrue, inaccurate, not current or incomplete, or
                  Cloudlas has reasonable grounds to suspect that such
                  information is untrue, inaccurate, not current or incomplete,
                  Cloudlas has the right to suspend or terminate your account
                  and refuse any and all current or future use of the Service
                  (or any portion thereof).
                </span>
              </p>
              <h3>BILLING</h3>
              <p>
                We will bill you for subscription fees corresponding to your
                first subscription period, plus any applicable tax, at the
                moment your subscription starts. Unless otherwise stated
                explicitly, a subscription period has a duration of one year.
              </p>
              <p>
                Unless cancelled, your Service subscription will be
                automatically renewed at the end of your subscription period. We
                will bill the subscription fee plus any applicable tax to you.
                Your membership will automatically renew for successive
                subscriptions, without prior notice to you, unless and until you
                cancel your membership, or we terminate it.
              </p>
              <p>
                {" "}
                You must cancel your membership before it renews in order to
                avoid billing of the next period’s subscription fees to your
                payment method.
              </p>
              <p>
                By using the Service, you are expressly agreeing that we are
                permitted to bill you a subscription fee, any applicable tax and
                any other charges you may incur in connection with your use of
                the Service. Additional charges may include service level
                changes you request.
              </p>
              <p>
                {" "}
                Such additional charges can be requested in the middle of a
                subscription period, and will be billed immediately, in the
                amount corresponding to the remainder of the period. The
                subscription fee will be billed at the beginning of your
                subscription and on each renewal thereafter, unless and until
                you cancel your membership.
              </p>
              <p>
                {" "}
                We will automatically bill you each billing period on the
                calendar day corresponding to the commencement of your
                membership. All fees and charges are nonrefundable, and there
                are no refunds or credits for partially used periods, or where
                you have elected to downgrade service levels or otherwise remove
                any paid component or feature.{" "}
              </p>
              <p>
                If you elect to upgrade your service level or otherwise add any
                paid component or feature, we will pro-rate the amount due based
                on the number of days remaining in your billing cycle; provided,
                however, that any such proration shall be based on your service
                level or paid components or features in existence immediately
                prior to your election to upgrade or add paid components or
                features.
              </p>
              <p>
                {" "}
                We may change the fees and charges in effect or add new fees and
                charges from time to time. We will inform you of any increase or
                addition to existing fees and we may offer you a grace-period in
                which your fees will not increase for a certain period of time.
                If you do not accept the increase or addition to the existing
                fees, you may elect to terminate your account during the then
                current billing period and you shall not be liable for such fee
                increase after the applicable billing period; however, any later
                renewal of service will be subject to the increased fee
                structure. If your credit or debit card reaches its expiration
                date, your continued use of the Service constitutes your
                authorization for us to continue billing you, and you remain
                responsible for any uncollected amounts.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsOfUse;
